import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase } from '../base/component-base';
import { CookiesLocalService } from '../service/cookies-local.service';
import { ApplicantService } from '../service/applicant.service';
import { ToastrService } from 'ngx-toastr';
import { IApplicant } from '../model/IApplicant';
import { BehaviorModelChangeService } from '../service/behavior-model-change.service.service';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.css']
})
export class UploadImageComponent extends ComponentBase implements OnInit {

photoUrl: any;

    imageFormData: FormData;
    applicantData: IApplicant;

title = 'Applicant\'s Picture Upload.';

    constructor(private router: Router,
                private toastr: ToastrService,
                behaviorModelChangeService: BehaviorModelChangeService,
                cookieLocalService: CookiesLocalService, applicantService: ApplicantService) {
      super(applicantService, cookieLocalService, behaviorModelChangeService);
      this.photoUrl = this.applicantData.PhotoUrl;
    }
 goToPrevious() {
                  this.router.navigate(['/applicant/info/notices']);
    }
    onSelectFile(event: any) {

      const files = event.target.files;
      const file = files[0];

      if (files && file) {

      // check file is valid
      if (!this.validateFile(file.name)) {
          console.log('Selected file format is not supported');
          return false;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file); // read file as data url




      reader.onload = (e) => { // called once readAsDataURL is completed
            this.photoUrl = reader.result;

            // const extension = file.type.split('/', 2)[1];
            const fileName = file.name;
            // const blobData = this.photoUrl.split(',', 2)[1];

            this.imageFormData = new FormData();
            this.imageFormData.append('file', file, fileName);
            this.imageFormData.append('folderPath', '/Content/ApplicantPassport/');
            this.imageFormData.append('id', this.applicantData.StudentNumber);
      };

    }


    }

    validateFile(name: string) {
      const ext = name.substring(name.lastIndexOf('.') + 1);
      if (ext.toLowerCase() === 'png' || ext.toLowerCase() === 'jpg' || ext.toLowerCase() === 'jpeg') {
          return true;
      } else {
          return false;
      }
  }


  ngOnInit() {
  }

 goToNext() {

    if (this.imageFormData) {
        this.applicantService.UploadUserPicture(this.imageFormData).subscribe(data => {

          // console.log(data);

          this.applicantService.getApplicant(this.applicantData.StudentNumber).subscribe(model => {
                this.behaviorModelChangeService.onUserPictureChanged(model.PhotoUrl);
            });
        }, error => {
            console.log(error);
        });
    }
    this.router.navigate(['/applicant/info/personal/basic']);

    }
}


